/**
 * @file JS - Controller - RasterLayerController.js
 * @author : Adam Lemire
 * @since 2019/11/18
 * @version 1.1
 * @summary Dernières modifications : 2020/11/05
 */

import RasterLayer from '../../classes/Layer/RasterLayer.js'; // eslint-disable-line no-unused-vars
import LayerController from './LayerController';
import { GisSection, LayerProperties } from '../../helpers/Selectors.js';

/**
 * @classdesc sous-controller de LayerController
 * @augments LayerController
 */
export default class RasterLayerController extends LayerController {
  constructor () {
    super();
    /** @type { RasterLayer } */
    this._layer = undefined;
  }

  get layer () { return this._layer; }

  /** @override */
  set layer (layer) {
    this._layer = layer;
    if ($('#map-layers__layer-' + layer.id).length === 0) {
      this._ajouterCoucheDansMenuListeCouches(layer);
    }
  }

  /** @param { RasterLayer } layer */
  static créerSymboleLégende (layer) {
    const parentDiv = '.map-layers__legend-' + layer.id;
    const symbolDiv = '<div class="legend__single-symbol legend__single-symbol--raster"></div>';

    $(parentDiv).empty();
    $(parentDiv).append(symbolDiv);
  }

  /*
   * OVERRIDE - LAYER PROPERTIES
   */

  /** @override */
  _updateLayerPropertiesListeners () {
    const _this = this;
    $(LayerProperties.BUTTON.APPLY).off('click tap').on('click tap', () => _this._modifierPropriétés());
    $(LayerProperties.OPACITY_SLIDER).off('input change').on('input change', () => $(LayerProperties.OPACITY_VALUE).html(Math.round(parseFloat($(LayerProperties.OPACITY_SLIDER).val()) * 100) + '%'));
  }

  /** @override */
  _updateLayerPropertiesStyleView () {
    const layer = this._layer;
    $(LayerProperties.OPACITY_SLIDER).val(layer.opacity);
    $(LayerProperties.OPACITY_VALUE).html((layer.opacity * 100) + '%');
    $(LayerProperties.SECTION_RASTER).show();
    $(LayerProperties.SECTION_VECTOR).hide();
    $(LayerProperties.LAYER_SOURCE_VECTOR).hide();
  }

  /*
   * OVERRIDE - APPLY PROPERTIES
   */

  /** @override */
  _modifierStyle () {
    this._layer.opacity = $(LayerProperties.OPACITY_SLIDER).val();
  }

  /*
   * OVERRIDE - LEFT-MENU : MAP_LAYERS
   */

  /**
   * @override
   * @param { RasterLayer } layer
   */
  _créerDivCoucheDansListeCouches (layer) {
    const checked = layer.isVisible ? 'checked' : '';
    const divId = '#map-layers__layer-' + layer.id;

    $(GisSection.MAP_LAYERS_CONTAINER).prepend('<div id="map-layers__layer-' + layer.id + '" class="map-layers__layer map-layers__layer--raster map-layers__layer-' + layer.id + '">' +
      '<div class="map-layers__text map-layers__text-' + layer.id + '">' + layer.name + '</div>' +
      '<input type="checkbox" class="map-layers__checkbox map-layers__checkbox-' + layer.id + '" ' + checked + '>' +
      '<div class="map-layers__legend map-layers__legend-' + layer.id + '"></div>' +
      '<div class="map-layers__move-icon"></div>' +
      '<div class="map-layers__separator"></div>' +
      '</div>');

    $(divId).data('layerId', layer.id);

    RasterLayerController.créerSymboleLégende(layer);
  }
}
